export const author = 'J\'ko Team';
export const contact = 'hello@selify.ai';

// Removed GitHub and Codeberg repos as requested


export const appName = 'J\'ko';
export const domain = 'https://selify.ai';

// Company information (Legal Entity)
export const companyName = 'Up Go Corp.';
export const companyUrl = 'https://upgo.ca';
export const companyNameShort = 'upgo.ca';

// Legal links
export const legalLinks = [
  {path: '/privacy', label: 'Privacy Policy'},
  {path: '/terms', label: 'Terms of Service'},
  {path: '/acceptable-use', label: 'Acceptable Use'}
];
